var Pixel = Pixel || {};

Pixel.GA = (function (PixelBase) {
    var GA = PixelBase.extend({
    	initialize: function (opts) {
		    opts = opts || {};
		    this._getAPI()('create', this._id, opts.domain);
        },

        pageView: function () {
            this._getAPI()('send', 'pageview');			
        },

        purchaseSuccess: function (opts) {
        	opts = opts || {};
        	var data = opts.OrderInfoResult;

        	this._getAPI()('send', 'pageview', 'PaymentSuccess');

        	this._getAPI()('require', 'ecommerce');

        	ga('ecommerce:addTransaction', {
        		'id': data.InvoiceNo,			// Transaction ID. Required
        		'affiliation': data.SaleName,	// Affiliation or store name
        		'revenue': data.Total,			// Grand Total
        		'shipping': data.Shipping,		// Shipping
        		'tax': data.Tax					// Tax
        	});

        	if (data.Items) {
        		$.each(data.Items, function () {
        			ga('ecommerce:addItem', {
        				'id': data.InvoiceNo,		// Transaction ID. Required
        				'name': this.ProductName,	// Product name. Required
        				'sku': this.Sku,			// SKU/code
        				'category': this.SizeName,	// Category or variation
        				'price': this.Price,		// Unit price
        				'quantity': this.Quantity	// Quantity
        			});
        		});
        	}

        	ga('ecommerce:send');
        },

        _getAPI: function () {
            return this._api || window.ga;
        }
    });

    return GA;
})(Pixel.PixelBase);

!function (Pixel, GlobalSettings) {
    if (!GlobalSettings.CAE) {
        return;
    }

    (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date(); a = s.createElement(o),
        m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

    new Pixel.GA({
    	id: GlobalSettings.CAA,
    	domain: GlobalSettings.CADN
    });
}(Pixel, GlobalSettings);
